export default function nonEmptySelection(value: unknown): string | undefined {
  if (Array.isArray(value) && value.length === 0) return 'At least one option must be selected';
  return undefined;
}
